import { useSessionStorage } from '@vueuse/core';

export function useRefetch() {
    const shouldRefetchEverythingOnReload = useSessionStorage('lokarb:refetch-on-page-load', false);

    return {
        shouldRefetchEverythingOnReload,
    };
}
